export const messageTemplates = [
  '{username}さん、はじめまして！{mename}といいます。プロフィールを拝見して、気になったのでいいね!してみました！お話できたら嬉しいです。',
  'はじめまして！画像が素敵だったのでメッセージしました。仲良くなれたら嬉しいです、よろしくおねがいします！',
  'はじめまして、いいね!ありがとうございます！{mename}といいます。よかったらお話しましょう！',
  'はじめまして。{username}さんがとても好みで思わずメッセージしました！よかったら仲良くなりましょう！'
];
